import { Box, Container } from "@mui/material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import "./account.css";
import { theme } from "../../theme";
import { useEffect, useState } from "react";

function SettingProfit() {
    const [setting, setSetting] = useState();
    const [load, setLoad] = useState(true);
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    useEffect(() => {
        if (load === true) {
            axios.get(`${process.env.REACT_APP_API_URL}/profit/get`, {}).then((res) => {
                setSetting(res.data.data[0]);
                setLoad(false);
            });
        }
    }, [load]);
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = {
            id: setting?._id,
            nap1: Number(e.target.nap1.value),
            nap2: Number(e.target.nap2.value),
            nap3: Number(e.target.nap3.value),
            nap4: Number(e.target.nap4.value),
            nap5: Number(e.target.nap5.value),
            nap6: Number(e.target.nap6.value),
            nap7: Number(e.target.nap7.value),
            nap8: Number(e.target.nap8.value),
            nap9: Number(e.target.nap9.value),
            nap10: Number(e.target.nap10.value),
            v1: Number(e.target.v1.value),
            v2: Number(e.target.v2.value),
            v3: Number(e.target.v3.value),
            v4: Number(e.target.v4.value),
            v5: Number(e.target.v5.value),
            v6: Number(e.target.v6.value),
            v7: Number(e.target.v7.value),
            v8: Number(e.target.v8.value),
            v9: Number(e.target.v9.value),
            v10: Number(e.target.v10.value),
            top1: Number(e.target.top1.value),
            top2: Number(e.target.top2.value),
            top3: Number(e.target.top3.value),
            top4: Number(e.target.top4.value),
            top5: Number(e.target.top5.value),
            top6: Number(e.target.top6.value),
            top7: Number(e.target.top7.value),
            top8: Number(e.target.top8.value),
            top9: Number(e.target.top9.value),
            top10: Number(e.target.top10.value)
        };
        axios
            .put(`${process.env.REACT_APP_API_URL}/profit/update`, formData)
            .then((res) => {
                setLoad(true);
                swal(t('success'), "", "success");
            })
            .catch((res) => setLoad(true));
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    {
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                py: 8
                            }}>
                            <Container maxWidth={false}>
                                <div style={{ fontSize: "25px", fontWeight: 700 }}>{t("setting")} VIP</div>
                                <div style={{ marginTop: "20px" }}>
                                    <form className="setting" onSubmit={handleSubmit}>
                                        <h3
                                            style={{
                                                width: "100%",
                                                flex: "0 0 100%",
                                                textAlign: "left",
                                                fontWeight: "bold",
                                                margin: "30px 10px 10px"
                                            }}>
                                            {t("top_reward")}
                                        </h3>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Thưởng thăng cấp VIP 1</label>
                                                <input defaultValue={setting?.top1} type="number" name="top1" step="any" id="top1" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Thưởng thăng cấp VIP 2</label>
                                                <input defaultValue={setting?.top2} type="number" name="top2" step="any" id="top2" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Thưởng thăng cấp VIP 3</label>
                                                <input defaultValue={setting?.top3} type="number" name="top3" step="any" id="top3" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Thưởng thăng cấp VIP 4</label>
                                                <input defaultValue={setting?.top4} type="number" name="top4" step="any" id="top4" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Thưởng thăng cấp VIP 5</label>
                                                <input defaultValue={setting?.top5} type="number" name="top5" step="any" id="top5" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Thưởng thăng cấp VIP 6</label>
                                                <input defaultValue={setting?.top6} type="number" name="top6" step="any" id="top6" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Thưởng thăng cấp VIP 7</label>
                                                <input defaultValue={setting?.top7} type="number" name="top7" step="any" id="top7" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Thưởng thăng cấp VIP 8</label>
                                                <input defaultValue={setting?.top8} type="number" name="top8" step="any" id="top8" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Thưởng thăng cấp VIP 9</label>
                                                <input defaultValue={setting?.top9} type="number" name="top9" step="any" id="top9" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Thưởng thăng cấp VIP 10</label>
                                                <input defaultValue={setting?.top10} type="number" name="top10" step="any" id="top10" className="input_setting" />
                                            </div>
                                        </div>
                                        <h3
                                            style={{
                                                width: "100%",
                                                flex: "0 0 100%",
                                                textAlign: "left",
                                                fontWeight: "bold",
                                                margin: "30px 10px 10px"
                                            }}>
                                            {t('up_vip')}
                                        </h3>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Mức nạp Vip 1</label>
                                                <input
                                                    defaultValue={setting?.nap1}
                                                    type="number"
                                                    name="nap1"
                                                    step="any"
                                                    id="nap1"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Mức nạp Vip 2</label>
                                                <input defaultValue={setting?.nap2} type="number" name="nap2" step="any" id="nap2" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Mức nạp Vip 3</label>
                                                <input defaultValue={setting?.nap3} type="number" name="nap3" step="any" id="nap3" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Mức nạp Vip 4</label>
                                                <input defaultValue={setting?.nap4} type="number" name="nap4" step="any" id="nap4" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Mức nạp Vip 5</label>
                                                <input defaultValue={setting?.nap5} type="number" name="nap5" step="any" id="nap5" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Mức nạp Vip 6</label>
                                                <input defaultValue={setting?.nap6} type="number" name="nap6" step="any" id="nap6" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Mức nạp Vip 7</label>
                                                <input defaultValue={setting?.nap7} type="number" name="nap7" step="any" id="nap7" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Mức nạp Vip 8</label>
                                                <input defaultValue={setting?.nap8} type="number" name="nap8" step="any" id="nap8" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Mức nạp Vip 9</label>
                                                <input defaultValue={setting?.nap9} type="number" name="nap9" step="any" id="nap9" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Mức nạp Vip 10</label>
                                                <input defaultValue={setting?.nap10} type="number" name="nap10" step="any" id="nap10" className="input_setting" />
                                            </div>
                                        </div>
                                        <h3
                                            style={{
                                                width: "100%",
                                                flex: "0 0 100%",
                                                textAlign: "left",
                                                fontWeight: "bold",
                                                margin: "30px 10px 10px"
                                            }}>
                                            {t('saving_rate')}
                                        </h3>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Quà SN Vip 1</label>
                                                <input defaultValue={setting?.v1} type="number" name="v1" step="any" id="v1" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Quà SN Vip 2</label>
                                                <input defaultValue={setting?.v2} type="number" name="v2" step="any" id="v2" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Quà SN Vip 3</label>
                                                <input defaultValue={setting?.v3} type="number" name="v3" step="any" id="v3" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Quà SN Vip 4</label>
                                                <input defaultValue={setting?.v4} type="number" name="v4" step="any" id="v4" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Quà SN Vip 5</label>
                                                <input defaultValue={setting?.v5} type="number" name="v5" step="any" id="v5" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Quà SN Vip 6</label>
                                                <input defaultValue={setting?.v6} type="number" name="v6" step="any" id="v6" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Quà SN Vip 7</label>
                                                <input defaultValue={setting?.v7} type="number" name="v7" step="any" id="v7" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Quà SN Vip 8</label>
                                                <input defaultValue={setting?.v8} type="number" name="v8" step="any" id="v8" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Quà SN Vip 9</label>
                                                <input defaultValue={setting?.v9} type="number" name="v9" step="any" id="v9" className="input_setting" />
                                            </div>
                                        </div>

                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Quà SN Vip 10</label>
                                                <input defaultValue={setting?.v10} type="number" name="v10" step="any" id="v10" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col" style={{ clear: "both", width: "100%" }}>
                                            <button type="submit" className="btn_setting">
                                                {t('save')}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </Container>
                        </Box>
                    }
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}

export default SettingProfit;
